import services from '@/config/services'

const source = 'clientiDataTable'
const baseUrl = `${services.ask_api.url}/management`

// per scaricare estratto conto direttamente dalla pagina dettagli

// const downloadFilePdf = async(url) => {
//   console.log(url)
//   try {

//     const res = await axios({
//       url,
//       method: 'GET',
//       responseType: 'blob',
//     })
//     const blob = new Blob([res.data], {type: 'application/pdf'});
//     const fileName= window.decodeURI(res.headers['content-disposition'].split('=')[1], "UTF-8").split('"').join('')

//     const downloadUrl = window.URL.createObjectURL(blob);
//     const link = document.createElement('a');
//     link.href = downloadUrl;
//     link.setAttribute('download', fileName);
//     document.body.appendChild(link);
//     link.click();
//     link.remove();
//   } catch (err) {
//     // this.eventBus.emit('data-load-error', {message: err, url})
//     console.log(err)
//   }
// }

const downloadFileZip = async(self, ids) => {
  const url = `${baseUrl}/clienti/estratti-conto/zip`

  try {
    const res = await self.$http({
      url,
      method: 'POST',
      data: {
        "filters":{
          "cliente.ids": ids
        },
      },
      responseType: 'blob',
    })
    
    const blob = new Blob([res.data], {type: 'application/zip'});
    const fileName= window.decodeURI(res.headers['content-disposition'].split('=')[1], "UTF-8").split('"').join('')

    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (err) {
    console.log(err)
  }
}

const getEstrattoConto = function(){
  const keys = Object.keys(this.filtered.ids).filter((s) => s == source)
  if(keys.length > 0){
    // this.filtered.ids[source].map((el) => el.value).forEach((el) => {
    //   const url = `${baseUrl}/clienti/${el}/estratto-conto/pdf`
    //   downloadFilePdf(url)
    // })

    const ids = this.filtered.ids[source].map((el) => el.value)
    downloadFileZip(this, ids);
  } 
}

export default {
  'bindTo': 'this',
  'method': getEstrattoConto,
}
